import React, { useEffect, useRef } from "react";
import { loadGoogleMapsScript } from "./loadGoogleMapsScript";

interface AutocompleteInputProps {
  id: string
  apiKey: string;
  placeholder: string;
  className?: string;
  onPlaceSelected: (place: string) => void;
  options?: google.maps.places.AutocompleteOptions;
}

const AutocompleteInput: React.FC<AutocompleteInputProps> = ({
  apiKey,
  id,
  placeholder,
  className,
  onPlaceSelected,
  options,
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    loadGoogleMapsScript(apiKey);

    const handleScriptLoad = () => {
      if (!inputRef.current) return;

      const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, options);

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (place && place.formatted_address) {
          onPlaceSelected(place.formatted_address);
        }
      });
    };

    const scriptCheckInterval = setInterval(() => {
      if (window.google && window.google.maps && window.google.maps.places) {
        handleScriptLoad();
        clearInterval(scriptCheckInterval);
      }
    }, 100);

    return () => clearInterval(scriptCheckInterval);
  }, [apiKey, onPlaceSelected, options]);

  return (
    <input
      ref={inputRef}
      type="text"
      placeholder={placeholder}
      className={className}
      id={id}
    />
  );
};

export default AutocompleteInput;
